import { WizardChrome } from "@/components/mentor-profile/wizard-chrome";
import { useCurrentUser } from "@/lib/api/user";
import { useIntercom } from "@/lib/hooks/use-intercom";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_mentor_profile")({
  component: () => <MentorProfileLayout />,
  beforeLoad: async ({ context }) => {
    if (!context.stytchSession?.session_id || !context.user?.id) {
      throw redirect({ to: "/login" });
    }

    // @todo - might need other checks in future
  },
});

function MentorProfileLayout() {
  const { data: user } = useCurrentUser();
  useIntercom(user, "onboarding");

  return (
    <div className="relative h-screen w-screen overflow-hidden bg-surfaces-z3">
      <Outlet />
      <WizardChrome />
    </div>
  );
}
